import styled from "styled-components";
import VehicleStatusImage from "../../assets/vehicle-status-background.svg";
import { media } from "../../../../utils/breakpoints";

export const VehicleOnWayBodyStyled = styled.div<{
  background: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 480px;
  height: 108px;
  margin-top: 32px;
  background: ${({ background }) => background} url(${VehicleStatusImage})
    no-repeat bottom right;
  padding: 24px;
  font-family: "Readex Pro", sans-serif;

  ${media.tablet} {
    width: clamp(320px, 38vw, 480px);
    height: 88px;
    margin-top: 16px;
    padding: 16px;
  }
`;

export const StatusNameStyled = styled.div`
  font-weight: 300;
  /* 20px tablet → toward 24px desktop. */
  font-size: clamp(20px, 1.3vw, 24px);
  color: #172a3f;

  ${media.portrait} {
    /* Label sits beside the queue number on a single 72px row. */
    font-size: 13px;
    line-height: 1.2;
  }
`;

export const PlaceInQueueStyled = styled.div`
  display: flex;
  align-items: baseline;
  font-size: clamp(20px, 1.3vw, 24px);

  ${media.portrait} {
    font-size: 13px;
  }
`;

export const PlaceStyled = styled.div`
  /* 36px tablet → toward original 48px desktop. */
  font-size: clamp(36px, 3vw, 48px);
  letter-spacing: -0.02em;
  color: #172a3f;
  line-height: 1;

  ${media.tablet} {
    font-size: 32px;
  }

  ${media.portrait} {
    font-size: 28px;
    line-height: 1;
  }
`;

/* VehicleMissionStatus  */
export const VehicleMissionBodyStyled = styled.div<{
  background: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* 268px matches RightColumnStyled width — was 270px (2px overflow) */
  width: 268px;
  /* Fill the right column; the header drives the actual height. */
  height: 100%;
  /* Top-right chevron bevel. Absolute px on both axes keeps a clean 45°
     cut at any panel height. */
  clip-path: polygon(
    100% 100%,
    100% 42px,
    calc(100% - 42px) 0%,
    0% 0%,
    0% 100%
  );
  background: ${({ background }) => background} url(${VehicleStatusImage})
    no-repeat bottom right;
  padding: 16px 18px;
  gap: 4px;
  font-family: "Readex Pro", sans-serif;

  ${media.tablet} {
    width: 100%;
    padding: 14px 16px;
  }

  ${media.portrait} {
    /* Shares the row with the Call Vehicle button at 72px; flow side-by-side
       so the label and queue number don't stack and overflow. */
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    min-height: 0;
    padding: 8px 14px;
    gap: 8px;
    background-image: none;
    /* Smaller bevel — 42px would cover ~58% of the 72px height. */
    clip-path: polygon(
      100% 100%,
      100% 18px,
      calc(100% - 18px) 0%,
      0% 0%,
      0% 100%
    );
  }
`;
